import { FC, useContext } from 'react';
import { get, xor } from 'lodash';
import { Checkbox } from '@chakra-ui/react';
import { TableContext } from './';
import filterStyles from './AllFiltersDrawer.module.css';
import styles from './MultiCheckboxFilter.module.css';
type ChangeHandler = (newSelectedArray: string[]) => void;
interface DateRangeFilterProps {
  columnId?: string;
  onChange: ChangeHandler;
  value: string;
}
export const MultiCheckboxFilter: FC<DateRangeFilterProps> = ({
  columnId,
  onChange,
  value
}) => {
  const {
    filterInfo
  } = useContext(TableContext);
  const filter = filterInfo.find(filter => filter.columnId === columnId) as any;
  const options = get(filter, 'filterConfig.options', []) as any[];
  const showRequiredError = value.length === 0;
  return <div className={styles.checkboxContainer} data-sentry-component="MultiCheckboxFilter" data-sentry-source-file="MultiCheckboxFilter.tsx">
      <div>
        <span className={filterStyles.filterLabel}>{filter.columnName}</span>
        {showRequiredError && <span className={filterStyles.requiredError}>
            At least one selection required
          </span>}
      </div>
      {options.map(opt => {
      const isChecked = value.includes(opt.value);
      // Sorting array helps with comparison: initialValues <=> values
      const handleChange = () => onChange(xor(value, [opt.value]).sort());
      return <Checkbox colorScheme="luigisPants" isChecked={isChecked} key={opt.value} onChange={handleChange}>
            <span>{opt.label}</span>
          </Checkbox>;
    })}
    </div>;
};